export default function loadGoogleMaps(apiKey, callback) {
  // Callback has to be a string which is the function name and attached to the window scope.
  const gmapsScript = document.createElement('script');
  gmapsScript.async = true;
  gmapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}` +
    `&libraries=places,drawing&callback=${callback}`;
  const scripts = document.getElementsByTagName('script')[0];
  scripts.parentNode.insertBefore(gmapsScript, scripts);
}



/** WEBPACK FOOTER **
 ** ./src/js/utils/google-maps.js
 **/